import classNames from 'classnames';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import type { FormattedMessages } from '@alltrails/shared/types/FormattedMessages';
import useMobileWidth from 'hooks/useMobileWidth';
import * as styles from './styles/collageStyles.module.scss';
import COLLAGE_ALTS from './natureUnites.strings';

const getCollageAlts = (alts: FormattedMessages<typeof COLLAGE_ALTS>): Record<number, string> => ({
  0: alts.IMG_0,
  1: alts.IMG_1,
  2: alts.IMG_2,
  3: alts.IMG_3,
  4: alts.IMG_4
});

const NatureUnitesCollage = (): JSX.Element => {
  const { formattedDefaultMessages } = useFormatMessage(COLLAGE_ALTS);
  const alts = getCollageAlts(formattedDefaultMessages);
  const isMobileView = useMobileWidth();

  const getCollageImage = (idx: number, containerClassName?: string, photoWidth?: number): JSX.Element => {
    const picJpg = require(`../../../../assets/images/about/collage-${photoWidth ? `${photoWidth}w-` : ''}${idx}.jpg`);
    const picAvif = require(`../../../../assets/images/about/collage-${photoWidth ? `${photoWidth}w-` : ''}${idx}.avif`);
    const picWebp = require(`../../../../assets/images/about/collage-${photoWidth ? `${photoWidth}w-` : ''}${idx}.webp`);
    return (
      <picture className={classNames(containerClassName)}>
        <source srcSet={picAvif} type="image/avif" />
        <source srcSet={picWebp} type="image/webp" />
        <img src={picJpg} alt={alts[idx]} className={styles.collageImage} loading="lazy" />
      </picture>
    );
  };

  return (
    <div className={styles.collage}>
      {isMobileView ? (
        <div className={styles.collageCol}>
          {getCollageImage(0, styles.wideImageSmall, 1029 /* photoWidth */)}
          <div className={classNames(styles.collageRow, styles.bottomRow)}>
            {getCollageImage(4, null /* containerClassName */, 503 /* photoWidth */)}
            {getCollageImage(2, null /* containerClassName */, 503 /* photoWidth */)}
          </div>
        </div>
      ) : (
        <>
          <div className={classNames(styles.collageCol, styles.leftCol)}>
            {getCollageImage(0, styles.wideImage)}
            <div className={classNames(styles.collageRow, styles.bottomRow)}>
              {getCollageImage(1)}
              {getCollageImage(2)}
            </div>
          </div>
          <div className={classNames(styles.collageCol, styles.rightCol)}>
            {getCollageImage(3)}
            {getCollageImage(4)}
          </div>
        </>
      )}
    </div>
  );
};

export { NatureUnitesCollage as default, COLLAGE_ALTS };
